import React, { Component } from "react";
import Datas from "../../data/facilities/ground.json";

import { Container, Row, Col } from "react-bootstrap";

import { Styles } from "./styles/events.js";

import { BreadcrumbBox } from "../../components/common/Breadcrumb.js";

import HeaderTwo from "../../components/HeaderTwo.js";
import FooterTwo from "../../components/FooterTwo.js";
import PopularGround from "../../components/facilities/PopularGround.js";

class Ground extends Component {
  render() {
    return (
      <Styles>
        {/* Main Wrapper */}
        <div className="main-wrapper event-details-page">
          {/* Header 2 */}
          <HeaderTwo />

          {/* Breadcrumb */}
          <BreadcrumbBox title="Playground" />

          {/* Playground Details Area */}
          <section className="event-details-area">
            <Container>
              <Row>
                <Col lg="9" md="8" sm="12">
                  <div className="event-details-content">
                    <div className="heading">
                      <h4>State-of-the-Art Playground for All Sports</h4>
                    </div>
                    <div className="event-icon">
                      <ul className="list-unstyled list-inline">
                        <li className="list-inline-item">
                          <i className="las la-futbol"></i> Football & Cricket
                        </li>
                        <li className="list-inline-item">
                          <i className="las la-basketball-ball"></i> Basketball
                          & Volleyball
                        </li>
                        <li className="list-inline-item">
                          <i className="las la-running"></i> Track & Field
                        </li>
                      </ul>
                    </div>
                    <div className="event-details-banner">
                      <img
                        src={
                          process.env.PUBLIC_URL + `/assets/images/play6.jpg`
                        }
                        alt="Playground"
                        className="img-fluid"
                      />
                    </div>
                    <div className="event-details-overview">
                      <h5>Playground Overview</h5>
                      <p>
                        Our playground is equipped with modern sports facilities
                        to support various games and activities. Students can
                        engage in football, basketball, cricket, and track &
                        field sports in a safe and well-maintained environment.
                        The ground is designed to encourage physical fitness,
                        teamwork, and competitive spirit.
                      </p>
                      <p>
                        With dedicated courts and well-maintained fields,
                        students can practice and participate in their favorite
                        sports in a safe and structured environment. The
                        playground is thoughtfully designed to promote physical
                        fitness, teamwork, and a competitive spirit, ensuring
                        that students not only develop their athletic skills but
                        also learn valuable life lessons such as discipline,
                        perseverance, and sportsmanship.
                      </p>
                      <ul className="list-unstyled">
                        <li>
                          <i className="fa fa-check"></i>
                          <span>
                            Spacious fields designed for multiple sports
                            including football, cricket, and other recreational
                            activities. The well-maintained turf ensures safety
                            and comfort for players, and the space is adaptable
                            for various tournaments.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check"></i>
                          <span>
                            {" "}
                            Organized sports tournaments, friendly matches, and
                            annual sports meets to encourage participation,
                            teamwork, and healthy competition among students.{" "}
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check"></i>
                          <span>
                            A modern track & field setup with a synthetic
                            running track, designated lanes for sprinters, and
                            facilities for long jump, high jump, and shot put.
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div className="event-details-speaker">
                      <h5> Playground</h5>
                      <Row>
                        {Datas.map((data, i) => (
                          <Col lg="3" md="6" sm="6" key={i}>
                            <div className="event-speaker-item">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  `/assets/images/${data.personImage}`
                                }
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                    {/* <div className="event-details-overview">
                      <h5>Playground Management Committee</h5>
                      <div>
                        <ul className="list-unstyled">
                          <li>
                            <i className="fa">1</i>
                            <span className="font-weight-bold"> Mr. Rohit Sharma </span>
                            <br />
                            <span>Chairman</span>
                          </li>
                        </ul>

                        <ul className="list-unstyled">
                          <li>
                            <i className="fa">2</i>
                            <span> Ms. Neha Kapoor </span>
                          </li>
                        </ul>

                        <ul className="list-unstyled">
                          <li>
                            <i className="fa">3</i>
                            <span> Mr. Amit Verma </span>
                          </li>
                        </ul>

                        <ul className="list-unstyled">
                          <li>
                            <i className="fa">4</i>
                            <span> Ms. Riya Nair </span>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                  </div>
                </Col>

                <Col lg="3" md="4" sm="12">
                  <div className="event-details-sidebar">
                    <Row>
                      <Col md="12">
                        <div className="event-sidebar-info">
                          <ul className="list-unstyled event-info-list">
                            <li>
                              Sports: <span>Football, Cricket, Basketball</span>
                            </li>
                            <li>
                              Facilities: <span>Track, Outdoor Gym</span>
                            </li>
                            <li>
                              Supervision: <span>Trained Coaches</span>
                            </li>
                            <li>
                              Events: <span>Annual Sports Meet</span>
                            </li>
                            <li>
                              Membership: <span>Open to All Students</span>
                            </li>
                          </ul>
                        </div>
                      </Col>
                      <Col md="12">
                        <PopularGround />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {/* Footer 2 */}
          <FooterTwo />
        </div>
      </Styles>
    );
  }
}

export default Ground;
